import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.dealStatusList,"item-value":"id","item-text":"name","label":_vm.label || 'Status',"rules":[_vm.requiredCheck()],"clearable":true,"outlined":""},model:{value:(_vm.idValue),callback:function ($$v) {_vm.idValue=$$v},expression:"idValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }